module.exports = slug => `/${slug || ''}/`.replace(/\/+/g, '/');



// WEBPACK FOOTER //
// ./src/utils/format-link.js